
import type { RouteObject } from 'react-router-dom';
import { lazy } from 'react';

const Home = lazy(() => import('../pages/home/page'));
const Dashboard = lazy(() => import('../pages/dashboard/page'));
const PlanBronce = lazy(() => import('../pages/plan-bronce/page'));
const PlanPlata = lazy(() => import('../pages/plan-plata/page'));
const PlanOro = lazy(() => import('../pages/plan-oro/page'));
const GestionFondeo = lazy(() => import('../pages/gestion-fondeo/page'));
const GestionCuentasReales = lazy(() => import('../pages/gestion-cuentas-reales/page'));
const PlanEstudio = lazy(() => import('../pages/plan-estudio/page'));
const Recursos = lazy(() => import('../pages/recursos/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <Home />
  },
  {
    path: '/formacion-trading',
    element: <PlanEstudio />
  },
  {
    path: '/dashboard',
    element: <Dashboard />
  },
  {
    path: '/plan-bronce',
    element: <PlanBronce />
  },
  {
    path: '/plan-plata',
    element: <PlanPlata />
  },
  {
    path: '/plan-oro',
    element: <PlanOro />
  },
  {
    path: '/gestion-fondeo',
    element: <GestionFondeo />
  },
  {
    path: '/gestion-cuentas-reales',
    element: <GestionCuentasReales />
  },
  {
    path: '/recursos',
    element: <Recursos />
  },
  {
    path: '*',
    element: <NotFound />
  }
];

export default routes;
